import PropTypes from "prop-types";
import { useState } from "react";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import InviteUserFormModal from "@/pages/user_management/components/Invite_User_Form_Modal";
import { resolveRoleName } from "@/utils/organization_id";

const UserCard = ({ user, onDelete }) => {
  const navigate = useNavigate();
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

  // Provide fallbacks for all potentially undefined values
  const {
    _id = "",
    fullname = "Unknown User",
    email = "No email provided",
    roles = [],
    status = "unknown",
    profileImage = null,
  } = user || {};

  const roleLabel = resolveRoleName(roles) || "User";

  const handleCardClick = (e) => {
    if (e.target.closest("button")) return;
    navigate(`/dashboard/users/${_id}`);
  };

  const handleMenuClick = ({ key }) => {
    if (key === "delete") {
      // Call parent's delete function with the id so it can find the _id
      onDelete(_id, fullname);
    } else if (key === "modify") {
      setIsEditModalVisible(true);
    }
  };

  const menuItems = {
    items: [
      {
        key: "modify",
        label: "Modify",
      },
      {
        key: "delete",
        label: "Delete",
      },
    ],
    onClick: handleMenuClick,
  };

  return (
    <>
      <div
        className="flex items-center text-left gap-4 p-1 rounded-lg shadow-sm bg-[var(--header-bg)] transition-all duration-300 cursor-pointer justify-between"
        onClick={handleCardClick}>
        {/* Left section with avatar, name, email, role, status */}
        <div className="flex items-center gap-4">
          <Avatar src={profileImage} alt={fullname} size={40} />

          {/* Name and Email */}
          <div className="flex flex-col min-w-0">
            <h3 className="text-bold font-semibold truncate w-[100px]">
              {fullname}
            </h3>
            <p className="text-small font-normal truncate w-[100px]">{email}</p>
          </div>

          {/* Role and Status */}
          <div className="flex flex-col">
            <span className="text-small whitespace-nowrap font-medium">
              {roleLabel}
            </span>
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full bg-primary"></div>
              <span className="text-small-xs font-medium text-primary">
                {status}
              </span>
            </div>
          </div>
        </div>

        {/* More Options - now positioned at the end */}
        <button
          className="p-2 rounded-full flex-shrink-0 ml-auto"
          onClick={(e) => e.stopPropagation()}>
          <Dropdown menu={menuItems} trigger={["click"]}>
            <CustomMoreOptions variant="filled" orientation="vertical" />
          </Dropdown>
        </button>
      </div>

      <InviteUserFormModal
        isVisible={isEditModalVisible}
        onClose={() => setIsEditModalVisible(false)}
        onUserCreated={() => {
          setIsEditModalVisible(false);
          // Optionally refresh the data
        }}
        userData={user}
        isEditMode={true}
      />
    </>
  );
};

UserCard.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string,
    fullname: PropTypes.string,
    email: PropTypes.string,
    roles: PropTypes.array,
    status: PropTypes.string,
    profileImage: PropTypes.string,
  }),
  onDelete: PropTypes.func,
};

export default UserCard;
